import { evaluateCan } from "@/permissions/v2/can";
import { usePermissionsV2Store } from "@/store/permissionsV2Store";

export const useCanReadSubscriptions = (firmId?: string): boolean =>
  usePermissionsV2Store((s) =>
    s.isLoaded && firmId
      ? evaluateCan(s.permissions, "subscriptions", "read", { firm_id: firmId })
      : false
  );

export const useCanCreateBillingPortal = (firmId?: string): boolean =>
  usePermissionsV2Store((s) =>
    s.isLoaded && firmId
      ? evaluateCan(s.permissions, "billings", "create", { firm_id: firmId })
      : false
  );
